import callCmAPI from 'services/helpers/call-cm-api'
import { WebApi2Response } from 'types'

/******************
 * Types          *
 ******************/

export interface GlobalDataUsageZone {
  name: string
  countries: string[]
  allocation: number | null
  usage: number
}

export interface CompanyGlobalDataUsage {
  company_id: number
  name: string
  country: string
  local_id: string
  plan: string
  zones: GlobalDataUsageZone[]
  total_allocation: number
  total_usage: number
}

export interface GlobalDataUsageTotals {
  companies: number
  allocation: number
  usage: number
  remaining: number
}

export interface GlobalDataUsagePagination {
  page: number
  page_size: number
  total: number
  pages: number
}

export interface GlobalDataUsageResponse {
  companies: CompanyGlobalDataUsage[]
  totals: GlobalDataUsageTotals
  // Optional only for rollout tolerance: RisikaAPI versions before the
  // pagination change return the full company list without this field.
  pagination?: GlobalDataUsagePagination
}

export interface GlobalDataUsageParams {
  page?: number
  pageSize?: number // One of 10, 20, 50, 100
  q?: string // Server-side search on company name or local_id
}

/******************
 * Fetch from API *
 ******************/

export const getGlobalDataUsage = (
  params: GlobalDataUsageParams = {},
): Promise<WebApi2Response<GlobalDataUsageResponse>> => {
  const searchParams = new URLSearchParams()
  if (params.page !== undefined) searchParams.set('page', String(params.page))
  if (params.pageSize !== undefined) {
    searchParams.set('page_size', String(params.pageSize))
  }
  if (params.q) searchParams.set('q', params.q)
  const queryString = searchParams.toString()

  return callCmAPI(`/global-data/usage${queryString ? `?${queryString}` : ''}`, {
    method: 'get',
  })
    .then((res) => {
      return { success: true as const, data: res.data as GlobalDataUsageResponse }
    })
    .catch((err) => {
      return {
        success: false as const,
        data: null,
        error: err,
      }
    })
}
